import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/layout/AppShell";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Doctors from "@/pages/Doctors";
import DoctorDetail from "@/pages/DoctorDetail";

import PatientDashboard from "@/pages/patient/Dashboard";
import PatientAppointments from "@/pages/patient/Appointments";
import PatientNotifications from "@/pages/patient/Notifications";
import PatientProfile from "@/pages/patient/Profile";

import DoctorDashboard from "@/pages/doctor/Dashboard";
import DoctorAppointments from "@/pages/doctor/Appointments";
import DoctorAvailability from "@/pages/doctor/Availability";
import DoctorProfile from "@/pages/doctor/Profile";

import AdminDashboard from "@/pages/admin/Dashboard";
import AdminDoctors from "@/pages/admin/Doctors";
import AdminPatients from "@/pages/admin/Patients";
import AdminAppointments from "@/pages/admin/Appointments";
import AdminSpecialties from "@/pages/admin/Specialties";

function RoleHome() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Landing />;
  if (user.role === "doctor") return <Navigate to="/doctor/dashboard" replace />;
  if (user.role === "admin") return <Navigate to="/admin/dashboard" replace />;
  return <Navigate to="/patient/dashboard" replace />;
}

const shell = (roles, El) => (
  <ProtectedRoute roles={roles}>
    <AppShell>
      <El />
    </AppShell>
  </ProtectedRoute>
);

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<RoleHome />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/doctors" element={<Doctors />} />
          <Route path="/doctors/:id" element={<DoctorDetail />} />

          <Route path="/patient/dashboard" element={shell(["patient"], PatientDashboard)} />
          <Route path="/patient/appointments" element={shell(["patient"], PatientAppointments)} />
          <Route path="/patient/appointments/:id" element={shell(["patient"], PatientAppointments)} />
          <Route path="/patient/notifications" element={shell(["patient"], PatientNotifications)} />
          <Route path="/patient/profile" element={shell(["patient"], PatientProfile)} />

          <Route path="/doctor/dashboard" element={shell(["doctor"], DoctorDashboard)} />
          <Route path="/doctor/appointments" element={shell(["doctor"], DoctorAppointments)} />
          <Route path="/doctor/availability" element={shell(["doctor"], DoctorAvailability)} />
          <Route path="/doctor/profile" element={shell(["doctor"], DoctorProfile)} />

          <Route path="/admin/dashboard" element={shell(["admin"], AdminDashboard)} />
          <Route path="/admin/doctors" element={shell(["admin"], AdminDoctors)} />
          <Route path="/admin/patients" element={shell(["admin"], AdminPatients)} />
          <Route path="/admin/appointments" element={shell(["admin"], AdminAppointments)} />
          <Route path="/admin/specialties" element={shell(["admin"], AdminSpecialties)} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
